<i [class]="getClass()"></i>